import { deleteTextMessage } from './deleteTextMessage';
import { fetchTextMessages } from './fetchTextMessages';
import { sendTestSms } from './sendTestSms';
import { sendUpsellAnnualFirstCtaSms } from './sendUpsellAnnualFirstCtaSms';
import { sendContactCardSms } from './sendContactCardSms';
import { sendOperatorTextMessage } from './sendOperatorTextMessage';

export const textMessageService = {
  deleteTextMessage,
  fetchTextMessages,
  sendTestSms,
  sendUpsellAnnualFirstCtaSms,
  sendContactCardSms,
  sendOperatorTextMessage,
};
